/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { Box, Button, Col, Row } from "@nordcloud/gnui";
import { useExternalIntegrationsQuery } from "~/generated/graphql";
import {
  BreadcrumbsBox,
  ReactTable,
  TableLoader,
  UniversalWrap,
  UnstyledLink,
} from "~/components";
import { ROUTES } from "~/routing/routes";
import { AddSandbox } from "~/views/externalIntegrations/components/AddSandbox";
import { ExternalIntegrationsColumns } from "./ExternalIntegrationsColumns";

const breadcrumbLabels = [
  {
    value: "external-integrations",
    label: "External Integrations",
  },
];

export function ExternalIntegrationsPage() {
  const columns = useMemo(() => ExternalIntegrationsColumns(), []);
  const { data, error, loading } = useExternalIntegrationsQuery();

  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="External Integrations"
            labels={breadcrumbLabels}
          >
            <AddSandbox />
            <UnstyledLink to={ROUTES.externalIntegrations.create}>
              <Button icon="plus">Add New Integration</Button>
            </UnstyledLink>
          </BreadcrumbsBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Box spacing="spacing04">
            <UniversalWrap
              errorProps={{ error }}
              loaderProps={{ loading, Component: Loader }}
            >
              <ReactTable
                striped
                columns={columns}
                sort={false}
                data={data?.externalIntegrations?.integrations ?? []}
              />
            </UniversalWrap>
          </Box>
        </Col>
      </Row>
    </>
  );
}

function Loader() {
  return (
    <TableLoader
      gapY={10}
      gapX={6}
      rows={[
        {
          count: 8,
          height: 60,
          items: [
            {
              widthPercent: 50,
            },
            {
              widthPercent: 25,
            },
            {
              widthPercent: 25,
            },
          ],
        },
      ]}
    />
  );
}
